<template>
  <v-tooltip top>
    <template v-slot:activator="{ on }">
      <div @click="onClick" style="cursor:pointer" v-on="on">
        <v-row no-gutters>
          <v-col cols="1">
            <v-icon x-large>mdi-account-circle</v-icon>
          </v-col>
          <v-col cols="11">
            <v-row no-gutters>
              <h4>{{version.autor}}</h4>
              <v-spacer></v-spacer>
              <v-icon icon color="primary">mdi-file</v-icon>
              <span class="ml-2 font-weight-bold">{{version.versionNumber}}</span>
              <span class="ml-2">{{version.date}}</span>
            </v-row>
            <v-row no-gutters>
              <span>{{version.text}}</span>
            </v-row>
          </v-col>
        </v-row>
        <v-divider class="my-2"></v-divider>
      </div>
    </template>
    <span>{{$t('SelectItem')}}</span>
  </v-tooltip>
</template>
<script>
export default {
  props: {
    version: {
      type: Object
    }
  },
  methods: {
    onClick() {
      this.$emit("on-click", this.version.documentId);
    }
  }
};
</script>